import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Role } from '@curbnturf/entities';
import { AuthService } from './auth.service';

/**
 * Defense-in-depth only — the real boundary is `GrowAuthGuard` on the
 * server (sales/salesManager/admin, `affiliateRef`-scoped rows). Signed-out
 * users go to /auth/login with a returnTo; signed-in non-sales/admin users go home.
 */
export const salesAccessGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const user = await auth.currentUserOnceLoaded();
  if (!user) {
    return router.createUrlTree(['/auth/login'], { queryParams: { returnTo: state.url } });
  }

  const hasGrowAccess = user.role === Role.sales || user.role === Role.salesManager || user.role === Role.admin;
  return hasGrowAccess ? true : router.createUrlTree(['/']);
};
